module.exports = __webpack_public_path__ + "media/night/308-05655fd0.svg";